const discoverData = [
  {
    id: 1,
    cardImg: 'assets/images/users/avatar-2.jpg',
    author: "Nancy Martino",
    title: "Owners",
    img: 'assets/images/nft/img-05.jpg',
    likes: "19.29k",
    price: "97.8 ETH",
    category: "Patterns arts &amp; culture",
  },
  {
    id: 2,
    cardImg: 'assets/images/users/avatar-9.jpg',
    author: "Henry Baird",
    title: "Creators",
    img: 'assets/images/nft/img-03.jpg',
    likes: "31.64k",
    price: "475.23 ETH",
    category: "Evolved Reality",
    isIcon: true,
  },
  {
    id: 3,
    cardImg: 'assets/images/users/avatar-10.jpg',
    author: "Diana Kohler",
    title: "Owners",
    img: 'assets/images/nft/gif/img-1.gif',
    likes: "8.34k",
    price: "701.38 ETH",
    category: "Long-tailed macaque",
  },
];
  
export { discoverData };
  